module.exports = __webpack_public_path__ + "static/media/school_money-logo--new.c4776dc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/school_money-logo--new.svg
// module id = 498
// module chunks = 0